<template>
<div class="tooltip-wrapper" @mouseenter="show = true" @mouseleave="show = false">
    <!-- element, na którym pojawia się tooltip -->
    <slot name="icon"></slot>

    <!-- sam tooltip -->
    <div v-if="show" class="tooltip-box">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "TooltipModal",
  data() {
    return {
      show: false
    }
  }
}
</script>

<style scoped>
.tooltip-wrapper {
  position: relative;
  display: inline-block;
}

.tooltip-box {
  position: absolute;
  bottom: 100%; /* wyświetla nad elementem */
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 6px;
  background: rgba(0, 0, 0, 0.85);
  color: #fff;
  padding: 5px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 1000;
  pointer-events: none;
}
</style>
